export enum MaintenanceStatus {
  Open = 'Open',
  Closed = 'Closed',
}

export enum Priority {
  VeryLow = 'Very Low',
  Low = 'Low',
  Moderate = 'Moderate',
  High = 'High',
  VeryHigh = 'Very High',
}

export enum Driver {
  Aesthetics = 'Aesthetics',
  Safety = 'Safety',
  Functionality = 'Functionality',
  WearAndTear = 'Wear and Tear',
  Damage = 'Damage',
  Financial = 'Financial',
  Compliance = 'Compliance',
  Disruption = 'Disruption',
}

export enum TreatmentType {
  Maintenance = 'Maintenance',
  Renewal = 'Renewal',
  Upgrade = 'Upgrade',
  Replacement = 'Replacement',
}
